import { DataBean } from "../../DataBean";


export class CIUO88ACAccount extends DataBean {

    public async getCIUO88ACAccount(acc: any,Date :any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.CIUO88ACAccount_getCIUO88ACAccount_Number_java.util.Date", [acc,Date ]);
    }
    public async getCIUO88ACAccountCatalog(acc: any,Date :any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getCIUO88ACAccountCatalog_Number_java.util.Date", [acc,Date ]);
    }
 public async addCIUO88ACAccountCatalog(acc: any,idLn:any,fromDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.CIUO88ACAccount_addCIUO88ACAccountCatalog_Number_Number_java.util.Date_Number", [acc,idLn,fromDate,idEmployee]);
    }

    // public async deleteBioIdentity(idBioIdentity: any): Promise<any> {
    //     return this.getCustomService("OrangeBase", "void_deleteBioIdentity_Number", [idBioIdentity]);
    // }
}